import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../Pages/Login";
import Candidate from "../Pages/Candidate/Index";
import CandidateExam from "../Pages/CandidateExam";
import AppHeader from "../layout/AppHeader";
import AppFooter from "../layout/AppFooter";
import User from "../Pages/User/Index";
import UserRole from "../Pages/UserRole/Index";
import TopicRule from "../Pages/TopicRule/index";
import InterviewQuestion from "../Pages/InterviewQuestion/index";
import Topic from "../Pages/Topic/index";
import ExamReport from "../Pages/ExamReport";
import StudentEntry from "../Pages/StudentEntry";

import { AuthProvider } from "../context/AuthContext";
import { ability } from "../ability/ability";
import {
  PERMISSIONS_ACTION,
  PERMISSIONS_MODEL,
} from "../library/utilities/constants/permissions";
import Unauthorized from "../components/Unauthorized";
import MessageProvider from "../context/MessageContext";

export const PermissionRoutes = ({ children, action, resource }: any) => {
  if (ability.can(action, resource)) {
    return children;
  } else {
    return <Navigate to="/unauthorized" />;
  }
};

function GlobalRouters() {
  return (
    <div className="layout-container">
      <AuthProvider>
        <MessageProvider>
          <AppHeader />

          <div className="layout-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              <Route element={<ProtectedRoute />}>
                <Route
                  path="/"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.ROLE_VIEW}
                      resource={PERMISSIONS_MODEL.ROLE}>
                      <UserRole />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/users"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.USER_VIEW}
                      resource={PERMISSIONS_MODEL.USER}>
                      <User />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/user-roles"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.ROLE_VIEW}
                      resource={PERMISSIONS_MODEL.ROLE}>
                      <UserRole />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/candidate"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.CANDIDATE_VIEW}
                      resource={PERMISSIONS_MODEL.CANDIDATE}>
                      <Candidate />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/topic-rules"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.USER_VIEW}
                      resource={PERMISSIONS_MODEL.USER}>
                      <TopicRule />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/interview-questions"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.USER_VIEW}
                      resource={PERMISSIONS_MODEL.USER}>
                      <InterviewQuestion />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/topics"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.USER_VIEW}
                      resource={PERMISSIONS_MODEL.USER}>
                      <Topic />
                    </PermissionRoutes>
                  }
                />

                <Route
                  path="/exam-reports"
                  element={
                    <PermissionRoutes
                      action={PERMISSIONS_ACTION.USER_VIEW}
                      resource={PERMISSIONS_MODEL.USER}>
                      <ExamReport />
                    </PermissionRoutes>
                  }
                />
              </Route>
              <Route path="/candidate-exam" element={<CandidateExam />} />
              <Route path="/student-entry" element={<StudentEntry />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <AppFooter />
        </MessageProvider>
      </AuthProvider>
    </div>
  );
}

export default GlobalRouters;
